import { createAction } from "@redux/actions/actionCreators";

const [useClearProduct, clearProduct] = createAction<{
  productUuid: string;
}>("product/clear");

export default useClearProduct;
export { clearProduct };
